/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class SeaTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'sea',
            'Sea Creatures',
            allLabels.sea,
            { numPairs: 6, ...options }
        );
    }
}
